var React = require('react');

function EProtein (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.547 5.864a2.946 2.946 0 112.136.996L4.234 22.834a1.178 1.178 0 01-2.136-.996l7.45-15.974z","fill":"#3CC3DD"}));
}

EProtein.defaultProps = {"fill":"none","viewBox":"0 0 16 25"};

module.exports = EProtein;

EProtein.default = EProtein;
